"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _typographyBreakpointConstants = require("typography-breakpoint-constants");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var theme = {
  title: "Wordpress Theme 2013",
  baseFontSize: "16px",
  baseLineHeight: 1.5,
  googleFonts: [{
    name: "Bitter",
    styles: ["700"]
  }, {
    name: "Source Sans Pro",
    styles: ["300i", "400", "400i", "700"]
  }],
  headerFontFamily: ["Bitter", "serif"],
  bodyFontFamily: ["Source Sans Pro", "sans-serif"],
  bodyColor: "hsla(0,0%,0%,0.93)",
  headerWeight: "700",
  bodyWeight: 400,
  boldWeight: 700,
  overrideStyles: function overrideStyles(_ref, options) {
    var _ref2;

    var adjustFontSizeTo = _ref.adjustFontSizeTo,
        scale = _ref.scale,
        rhythm = _ref.rhythm;
    return _ref2 = {
      h1: _extends({}, scale(8 / 5))
    }, _defineProperty(_ref2, _typographyBreakpointConstants.TABLET_MEDIA_QUERY, {
      h1: _extends({}, scale(5 / 5))
    }), _defineProperty(_ref2, "a", {
      color: "#bc360a",
      textDecoration: "none"
    }), _defineProperty(_ref2, "a:hover", {
      color: "#ea9629",
      textDecoration: "underline"
    }), _defineProperty(_ref2, "ol,ul", {
      marginLeft: 0,
      paddingLeft: rhythm(1.5)
    }), _defineProperty(_ref2, "li>ul,li>ol", {
      marginLeft: 0,
      paddingLeft: rhythm(1.5)
    }), _defineProperty(_ref2, "blockquote", _extends({}, scale(1 / 5), {
      fontWeight: 300,
      fontStyle: "italic",
      marginLeft: rhythm(1.5),
      marginRight: rhythm(1.5)
    })), _defineProperty(_ref2, "blockquote cite", _extends({}, adjustFontSizeTo(options.baseFontSize), {
      fontWeight: options.bodyWeight,
      textTransform: "uppercase"
    })), _defineProperty(_ref2, "h6", {
      marginTop: rhythm(1.25),
      marginBottom: rhythm(1.25)
    }), _defineProperty(_ref2, "table", _extends({}, scale(-1 / 5))), _defineProperty(_ref2, "th", {
      fontWeight: options.boldWeight,
      textTransform: "uppercase"
    }), _defineProperty(_ref2, "dl", {
      marginLeft: rhythm(3 / 4)
    }), _ref2;
  }
};
exports.default = theme;